import { render } from "./TemplateBrowserPanel.vue?vue&type=template&id=167f46ef&scoped=true"
import script from "./TemplateBrowserPanel.vue?vue&type=script&lang=js"
export * from "./TemplateBrowserPanel.vue?vue&type=script&lang=js"

import "./TemplateBrowserPanel.vue?vue&type=style&index=0&id=167f46ef&lang=scss&scoped=true"
import "./TemplateBrowserPanel.vue?vue&type=style&index=1&id=167f46ef&lang=scss"
script.render = render
script.__scopeId = "data-v-167f46ef"

export default script